import * as navigator from "client_legacy/ndaw/navigator";
import { OfficeWebAppOpenTarget } from "client/Api/Documents/SharePoint/common";
import { deviceHelper, documentsConfiguration } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import * as busyIndicator from "client_legacy/ndaw/busyIndicator";
import { EditorModes, WacVersion } from "client/Api/Documents/common";
import * as windowFactory from "client_legacy/ndaw/windowFactory";
import { openDocumentWindow } from "client/Features/Documents/DocumentWindow";
import { OpenInWopiModel, openInWopiPopup } from "client/Api/Documents/WebDav/webDavFileContent";
import { localize } from "client_legacy/ndaw/culture";
import { openAlertDialog } from "client/Components";
import { ContainerType } from "client_legacy/ndaw/busyIndicator";

export function open(serverId: number, fileId: string, fileName: string) {
	const { webDav: webDavConfiguration } = documentsConfiguration();

	if (!webDavConfiguration) {
		throw new Error("WebDav is not configured");
	}

	const openTarget: OfficeWebAppOpenTarget = webDavConfiguration.wopi.openTarget;
	switch (openTarget) {
		case OfficeWebAppOpenTarget.Popup:
			getDataForPopup(serverId, fileId)
				.then((openModel) => {
					showWopiInPopup(openModel.wopiUrl, fileName);
				});
			break;

		case OfficeWebAppOpenTarget.NewWorkspaceTab:
			const workspaceTabUrl = navigator.createUrlRelativeToEnvironment(
				"Documents/WebDav/" + serverId + "/WorkspaceInterfaceEditor?fileId=" + encodeURIComponent(fileId)
			);
			windowFactory.open(workspaceTabUrl);
			break;

		case OfficeWebAppOpenTarget.NewOffice365Tab:
			const officeTabUrl = navigator.createUrlRelativeToEnvironment(
				"Documents/WebDav/" + serverId + "/OfficeInterfaceEditor?fileId=" + encodeURIComponent(fileId)
			);
			windowFactory.open(officeTabUrl);
			break;

		default:
			throw new Error("Unsupported open target " + openTarget);
	}
}

async function getDataForPopup(serverId: number, fileId: string): Promise<OpenInWopiModel> {
	const busyIndicatorContainer: ContainerType = "body";
	busyIndicator.show(busyIndicatorContainer);

	const async: boolean = deviceHelper.wopi
		.areAsyncRequestsAllowed(OfficeWebAppOpenTarget.Popup);

	try {
		return await openInWopiPopup(
			serverId,
			fileId,
			async
		);
	} catch (e) {
		console.error(e);

		openAlertDialog({
			title: localize("_Error"),
			children: localize("_GeneralErrorMessage"),
			confirmText: localize("_Ok"),
			trackingId: "webdav-open-document-error-dialog"
		});

		throw e;
	} finally {
		busyIndicator.hide(busyIndicatorContainer);
	}
}

function showWopiInPopup(wopiUrl: string, fileName: string) {
	openDocumentWindow({
		file: {
			name: fileName
		},
		url: wopiUrl,
		version: WacVersion.Office365,
		shouldHideRibbon: false,
		editorMode: EditorModes.Edit,
		isResizable: deviceHelper.wopi.allowResizing()
	});
}
